var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatBubbles = function SvgChatBubbles(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 18a.97.97 0 0 1-.713-.288A.97.97 0 0 1 6 17v-2h13V6h2q.424 0 .712.287Q22 6.576 22 7v12.575q0 .674-.613.938-.612.262-1.087-.213L18 18zm-1-5-2.3 2.3q-.476.475-1.088.212Q2 15.25 2 14.576V3q0-.424.288-.712A.97.97 0 0 1 3 2h13q.424 0 .712.288Q17 2.575 17 3v9q0 .424-.288.713A.97.97 0 0 1 16 13zm9-2V4H4v7z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatBubbles);
export { ForwardRef as ReactComponent };